import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * CWSアイコン基本情報取得
 *
 * @export
 * @class GetCwsIconBaseData
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCwsIconBaseData extends PlessJsonResponderSub<any> {
  
  vo = {
    iconCode: '',
    iconCodeBranch: '',
  };

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCwsIconBaseData
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        IconCode: this.vo.iconCode,
        IconCodeBranch: this.vo.iconCodeBranch
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @memberof GetCwsIconBaseData
   */
  execute(vo: any, successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getCwsIconBaseData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCwsIconBaseData
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
